import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionContacts = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"type": "page",
			"properties": {
				"title": [
					[
						"Контакты"
					]
				]
			},
			"content": [
				"f6bcb834-c796-44ed-805e-dcb7675c680e",
				"51b710d4-552f-49d0-9b00-08008928cad8",
				"e9b9b90b-2d37-4c24-9358-479241872b30",
				"f67d4260-53d6-49e6-8b2e-98978650c847",
				"7686927b-aab1-4815-9416-c6c3d180ed7b",
				"3bff7cbb-1b2c-4ff9-aec8-c9663aa4d9db",
				"eb30470c-ad83-4210-b5c9-d5cec0869698",
				"e40b5301-5052-47f3-aad1-4a598f79260f",
				"37564f0c-3d23-42c7-8920-fb9a2eecd087"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f6bcb834-c796-44ed-805e-dcb7675c680e",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/contacts\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d95a2177-b1c9-409f-90cf-03329a3ab2bb",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "51b710d4-552f-49d0-9b00-08008928cad8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Подпишитесь на нас в социальных сетях, чтобы первыми узнавать о вакансиях, мероприятиях и других активностях."
					]
				]
			},
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9b9b90b-2d37-4c24-9358-479241872b30",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Новости"
					]
				]
			},
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f67d4260-53d6-49e6-8b2e-98978650c847",
			"type": "column_list",
			"content": [
				"69ceea5f-f639-4d02-a01b-6722c49dcb7d",
				"38d3b734-a291-42fa-9164-29f9203bc199"
			],
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7686927b-aab1-4815-9416-c6c3d180ed7b",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Картинки"
					]
				]
			},
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3bff7cbb-1b2c-4ff9-aec8-c9663aa4d9db",
			"type": "column_list",
			"content": [
				"de205e13-8792-4441-baef-336946eec06e",
				"2effad85-a159-445a-a83c-08a56fdd9565"
			],
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eb30470c-ad83-4210-b5c9-d5cec0869698",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Видео"
					]
				]
			},
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e40b5301-5052-47f3-aad1-4a598f79260f",
			"type": "column_list",
			"content": [
				"4254bf8b-bdb2-45b5-816a-efafd5b695ce",
				"95823400-3665-4367-bd47-f50c35a6ccaf"
			],
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "37564f0c-3d23-42c7-8920-fb9a2eecd087",
			"type": "text",
			"parent_id": "98a66dbd-731e-498f-9c5f-7790d1f555e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69ceea5f-f639-4d02-a01b-6722c49dcb7d",
			"type": "column",
			"content": [
				"808bc996-d272-4f26-a47b-c8012a8d73c1"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "f67d4260-53d6-49e6-8b2e-98978650c847",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "38d3b734-a291-42fa-9164-29f9203bc199",
			"type": "column",
			"content": [
				"52db2a89-55f5-4e2f-81e2-35d6ab2f20cf"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "f67d4260-53d6-49e6-8b2e-98978650c847",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "808bc996-d272-4f26-a47b-c8012a8d73c1",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://vk.com/vkdesignteam"
					]
				],
				"title": [
					[
						"VK Design Team"
					]
				],
				"caption": [
					[
						"Группа ВКонтакте"
					]
				],
				"description": [
					[
						"Дизайнеры VK рассказывают о работе над продуктами, дизайн-системе, конференциях и митапах, свежих публикациях."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://vk.com/images/icons/pwa/apple/default.png?15",
				"bookmark_cover": "https://sun6-21.userapi.com/s/v1/ig2/lpHNHZniVHkmgJp_JHqBz2oG6I-Odkd2KzINIQ2YdTWAqt-p7daflSVJM0-48lmMNgMLrcbVAu9-ZJ3OgfSAA-4y.jpg?size=200x200&quality=95&crop=88,76,601,601&ava=1"
			},
			"parent_id": "69ceea5f-f639-4d02-a01b-6722c49dcb7d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "52db2a89-55f5-4e2f-81e2-35d6ab2f20cf",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://t.me/mailrudesign"
					]
				],
				"title": [
					[
						"VK Design Team"
					]
				],
				"caption": [
					[
						"Группа в Телеграм"
					]
				],
				"description": [
					[
						"Дизайнеры VK рассказывают о работе над продуктами, дизайн-системе, конференциях и митапах, свежих публикациях."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://telegram.org/img/apple-touch-icon.png",
				"bookmark_cover": "https://cdn4.cdn-telegram.org/file/njKvSM_PJwpuSHjMFiHC0jm6SfOCEFKLcbZItM1uZ70MmluFUeP0--8Glxnd1a62W3hpMT-KnJ3JbP2W7gdo-UDfgGwNOMUy_0UFj59zdJLSIlh4AiRHkb8DNMt7BxnVTlRHBRM4L9JSHldhHKG1LsHNlnmnpD7tDm9B5IZLcZszWoXKAqCqj0XfTJQqWHDy844_rRiKK4JvNy8fMVOBOU5tzHavQGau1NckiUhePTQKxmtzlNommrCrODm8Ok9XkWO2Gsi3lYgA2MdiZBp7y5UTImn1LBzXdL8Ic7yYpVqz9IBjJ32cYDSvuh84TcySoCOmLim0ro4KPoc_4nZ2UA.jpg"
			},
			"parent_id": "38d3b734-a291-42fa-9164-29f9203bc199",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "de205e13-8792-4441-baef-336946eec06e",
			"type": "column",
			"content": [
				"1105a63f-9d7d-44aa-8518-e7df5f19d779"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "3bff7cbb-1b2c-4ff9-aec8-c9663aa4d9db",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2effad85-a159-445a-a83c-08a56fdd9565",
			"type": "column",
			"content": [
				"9413ed8a-7e18-48b2-92e5-3d635b7ff18c"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "3bff7cbb-1b2c-4ff9-aec8-c9663aa4d9db",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1105a63f-9d7d-44aa-8518-e7df5f19d779",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://dribbble.com/vkdesignteam"
					]
				],
				"title": [
					[
						"VK Design Team"
					]
				],
				"caption": [
					[
						"Наш Dribbble"
					]
				],
				"description": [
					[
						"VK Design Team Connect with them on Dribbble; the global community for designers and creative professionals."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://cdn.dribbble.com/assets/favicon-192x192-d70ad402693bdd1a8460da7f9f3c590e817da7369c5287789ac968cf6947d214.png",
				"bookmark_cover": "https://cdn.dribbble.com/userupload/12006006/file/original-b54eac8e5940aa58b10d145d38063b3a.png?resize=1600x1200"
			},
			"parent_id": "de205e13-8792-4441-baef-336946eec06e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9413ed8a-7e18-48b2-92e5-3d635b7ff18c",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.behance.net/vkdesignteam"
					]
				],
				"title": [
					[
						"VK Design Team"
					]
				],
				"caption": [
					[
						"Наш Behance"
					]
				],
				"description": [
					[
						"VK Design Team on Behance"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://a5.behance.net/5925ad0ee9b5cd02f37635b1ad3d87acaa66250d/img/site/apple-touch-icon.png?cb=264615658",
				"bookmark_cover": "https://mir-s3-cdn-cf.behance.net/user/276/9a34ba1357025.616576c6f2d17.png"
			},
			"parent_id": "2effad85-a159-445a-a83c-08a56fdd9565",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4254bf8b-bdb2-45b5-816a-efafd5b695ce",
			"type": "column",
			"content": [
				"7762efd6-b20f-4ab1-9c8f-b5bfd18f7b3d"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "e40b5301-5052-47f3-aad1-4a598f79260f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "95823400-3665-4367-bd47-f50c35a6ccaf",
			"type": "column",
			"content": [
				"747e6002-87e3-4cbb-bfef-2cd42f4e52a4"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "e40b5301-5052-47f3-aad1-4a598f79260f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7762efd6-b20f-4ab1-9c8f-b5bfd18f7b3d",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.youtube.com/vkdesignteam"
					]
				],
				"title": [
					[
						"VK Design Team"
					]
				],
				"caption": [
					[
						"Youtube"
					]
				],
				"description": [
					[
						"Привет, мы – команда дизайна VK (ex. mail design), делимся знаниями, ежегодно проводим серию дизайн-мероприятий и выкладываем материалы в этом ютуб-канале на различные темы: нейросети, типографика, брендинг цифровых продуктов, инклюзивный дизайн, иллюстрации, исследования, командная работа, разработка, аналитика, менеджмент, маркетинг, культура, дизайн и другие. Подписывайся на канал, будет много интересного."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.youtube.com/s/desktop/f23005ee/img/favicon_144x144.png",
				"bookmark_cover": "https://yt3.googleusercontent.com/AJHUldVnG-zUQ82p5KLhtYackiYm8Tvt_WtjdbawkW-MMvKHPMX2e1Kcw6y2EhFCrMAvOUzP=s900-c-k-c0x00ffffff-no-rj"
			},
			"parent_id": "4254bf8b-bdb2-45b5-816a-efafd5b695ce",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "747e6002-87e3-4cbb-bfef-2cd42f4e52a4",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://vk.com/video/@vkdesignteam"
					]
				],
				"title": [
					[
						"VK Design Team's Videos | VK"
					]
				],
				"caption": [
					[
						"VK Видео"
					]
				],
				"description": [
					[
						"VK Design Team — 170 videos. Watch online on VK"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://vk.com/images/icons/favicons/fav_vk_video_2x.ico?7"
			},
			"parent_id": "95823400-3665-4367-bd47-f50c35a6ccaf",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": []
}} />
);

export default NotionContacts;
